/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, OnInit} from '@angular/core';
import {completeCopyModal} from '../../common/util/complete-copy-modal';
import {Subject} from 'rxjs';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {createResourceCopy} from '../../../components/util/create-resource-copy';
import {nextCopyTitle} from '../../../components/util/next-copy-title';
import {Uuid} from '../../../components/util/uuid';
import {LayoutResource} from '../../../components/api/resources/resource/layout.resource';

export interface LayoutCopyResult {
  model: any;
  destination: boolean;
}

@Component({
  standalone: false,
  selector: 'adn-layout-copy-modal',
  template: `
    <form class="form-horizontal" (ngSubmit)="copy()">
      <div class="modal-header dialogAddStuff">
        <button type="button" class="close" (click)="dismiss()">&times;</button>
        <h4 class="modal-title">
          <span>{{ 'label.copy.layout' | ogTranslate }}</span>
          <small>{{originalName}}</small>
        </h4>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label class="col-md-3 control-label">Name</label>
          <div class="col-md-9">
            <input type="text" class="form-control" name="layout.name" [(ngModel)]="name" required>
          </div>
        </div>
        <div class="form-group">
          <label class="col-md-3 control-label">Description</label>
          <div class="col-md-9">
            <input type="text" class="form-control" name="layout.description" [(ngModel)]="description">
          </div>
        </div>
        <div class="checkbox text-right">
          <label class="checkbox">
            <input type="checkbox" [(ngModel)]="destination" name="layout.destination">
            <span class="small">Go to new layout after copy</span>
          </label>
        </div>
      </div>
      <div class="modal-footer">
        <a class="btn btn-link btn-xs" (click)="dismiss()">{{ 'button.cancel' | ogTranslate }}</a>
        <button type="submit" class="btn btn-default">{{ 'label.copy' | ogTranslate }}</button>
      </div>
    </form>
  `
})
export class LayoutCopyModalComponent implements OnInit {
  /** Set via BsModalService initialState */
  model: any;

  readonly onCopied = new Subject<LayoutCopyResult>();

  originalName = '';
  name = '';
  description = '';
  destination = true;

  constructor(
    public bsModalRef: BsModalRef,
    @Inject(LayoutResource) private readonly Layout: any
  ) {}

  ngOnInit(): void {
    this.originalName = this.model?.name || '';
    this.name = nextCopyTitle(this.model?.name || '');
    this.description = this.model?.description || '';
  }

  copy(): void {
    const layout = createResourceCopy(this.Layout, this.model, {
      id: Uuid.generate(),
      name: this.name,
      description: this.description
    });
    layout.$save().then((saved: any) => {
      completeCopyModal(this.bsModalRef, this.onCopied, {model: saved, destination: this.destination});
    });
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }
}
